import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TableCell } from 'smartsuite-ui/lib/table/TableCell';
import { AlertLevelCell } from 'smartsuite-ui/lib/alerts/AlertLevelCell';
import { InternalLink } from 'smartsuite-ui/lib/typography/InternalLink';
import { getSystemOrigin } from '../../../shared/hooks/linkHooks';
import DashboardContext from '../../../shared/hooks/dashboardContext';

const countCombinationSymbol = ' & ';
const defaultCustomCellValue = '−';

function getLink(flightId, path, linkConfig, systemManifest) {
    const systemOrigin = getSystemOrigin(linkConfig, systemManifest);
    const pathName = path.replace('FLIGHT_ID', flightId);

    return `${systemOrigin}${pathName}`;
}

export default function BagCargoCountLink(props) {
    const { columnConfig, resultRow } = props;
    const { systemManifest } = useContext(DashboardContext);

    if (!props.exists) {
        return <TableCell>{defaultCustomCellValue}</TableCell>;
    }

    const isCargoEnabled = resultRow[columnConfig.cargoPermission];
    const bagCount = resultRow[columnConfig.bagValueDataKey];
    const cargoCount = resultRow[columnConfig.cargoValueDataKey];
    const hasLinkAccess = resultRow[columnConfig.hasAccessDataKey];

    const formattedBagLink = getLink(
        resultRow[columnConfig.idDataKey],
        columnConfig.linkConfig.bagLink,
        columnConfig.linkConfig,
        systemManifest
    );

    const formattedCargoLink = getLink(
        resultRow[columnConfig.idDataKey],
        columnConfig.linkConfig.cargoLink,
        columnConfig.linkConfig,
        systemManifest
    );

    if (isCargoEnabled) {
        if (hasLinkAccess) {
            return (
                <AlertLevelCell alertLevelId={props.alertLevel}>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={formattedBagLink}
                    >
                        {bagCount}
                    </a>
                    {countCombinationSymbol}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={formattedCargoLink}
                    >
                        {cargoCount}
                    </a>
                </AlertLevelCell>
            );
        }
        return (
            <AlertLevelCell alertLevelId={props.alertLevel}>
                <div>
                    {bagCount}
                    {countCombinationSymbol}
                    {cargoCount}
                </div>
            </AlertLevelCell>
        );
    }
    return (
        <AlertLevelCell alertLevelId={props.alertLevel}>
            <InternalLink
                openInNewTab={true}
                href={formattedBagLink}
                canViewLink={hasLinkAccess}
            >
                {bagCount}
            </InternalLink>
        </AlertLevelCell>
    );
}

BagCargoCountLink.propTypes = {
    columnConfig: PropTypes.instanceOf(Object).isRequired,
    resultRow: PropTypes.instanceOf(Object).isRequired,
    alertLevel: PropTypes.number,
    exists: PropTypes.bool,
};
